import { render, staticRenderFns } from "./SGPoolingConfigSummary.vue?vue&type=template&id=1e28180a"
import script from "./SGPoolingConfigSummary.vue?vue&type=script&lang=js"
export * from "./SGPoolingConfigSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports